import {EventEmitter} from '@angular/core';

export abstract class SplitViewDetails<T> {
    abstract entity: T;
    canDeactivate(): boolean {
        return true;
    }
}

export abstract class BulkSplitViewDetails<T> {
   abstract selectedEntities: Array<T>;
    canDeactivate(): boolean {
        return true;
    }
}


export abstract class SplitViewFilter<T> {
    abstract entities: T[];
    entitiesChanged: EventEmitter<T[]> = new EventEmitter<T[]>();
}

export interface BulkModeConfig {
    initialState: boolean;
    bulkModeToggleCallback: (b: boolean) => void;
    toggleAllCallback: (b: boolean) => void;
}

export abstract class BulkSplitViewFilter<T> extends SplitViewFilter<T> {
    bulkModeConfig?: BulkModeConfig;
}

export abstract class SplitViewEntries<T> {
    abstract entities: T[];
    abstract compareKey: keyof T | ((e: T) => string);

    detailView: SplitViewDetails<T>;

    getCompareValue(e: T) {
        if (this.compareKey instanceof Function) {
            return this.compareKey(e);
        } else {
            return e[this.compareKey];
        }
    }
}

export abstract class BulkSplitViewEntries<T> extends SplitViewEntries<T> {
    abstract selecedEntities: T[];
    abstract bulkModeActive: boolean;

    bulkDetails: BulkSplitViewDetails<T>;

    toggleAll(b: boolean) {
        if (b) {
            this.selecedEntities = [...this.entities];
        } else {
            this.selecedEntities = [];
        }
    }

    isEntityToggled(e: T): boolean {
        return this.selecedEntities.map(entity => this.getCompareValue(entity)).includes(this.getCompareValue(e));
    }

    toggleEntity(e: T) {
        if (this.isEntityToggled(e)) {
            this.selecedEntities = this.selecedEntities.filter(x => this.getCompareValue(x) !== this.getCompareValue(e));
        } else {
            this.selecedEntities.push(e);
            this.selecedEntities = [...this.selecedEntities]; // trigger CD
        }
    }
}
